<template>
  <main class="main main--logout">
    <div class="group group--narrower group--last">
      <h1 
        v-if="message.title"
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h1 mw600">{{ message.title }}</h1>
      <p v-if="message.description" class="p">{{ message.description }}</p>
    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Models
import logoutModel from 'models/global/logout';

// Export
export default {
  name: 'view-logout',

  // Data
  data() {
    return {
      logoutModel,
    };
  },

  // Computed
  computed: {
    ...mapGetters('auth', ['logoutMessage']),
    ...mapGetters('app', ['org']),

    
    message() {
      return this.logoutModel && this.logoutModel[this.logoutMessage] || this.logoutModel.default;
    },
  },

  // Methods
  methods: {
    ...mapActions('auth', [
      'requestLogout',
    ]),
  },

  // Lifecycle
  created() {
    setTimeout(() => {

      this.requestLogout();
      if (this.message.popup) {
        localStorage.setItem('forcedLogout', true);
      }
    }, this.logoutMessage && 5000 || 0);
  },
};
</script>



// WEBPACK FOOTER //
// Logout.vue?1736ee9e